import { render, staticRenderFns } from "./CoupassFeedbackBoard.vue?vue&type=template&id=1aa5a9b2&scoped=true"
import script from "./CoupassFeedbackBoard.vue?vue&type=script&lang=js"
export * from "./CoupassFeedbackBoard.vue?vue&type=script&lang=js"
import style0 from "./CoupassFeedbackBoard.vue?vue&type=style&index=0&id=1aa5a9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa5a9b2",
  null
  
)

export default component.exports